module.exports = __webpack_public_path__ + "img/Slide20.79d17550.png";